import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { getPlayerState } from "../../../utils/amplitude-util";
import anime from "animejs/lib/anime.es";
import "./style.scss";
import { toggleCurrentSongPlay } from "../../../store/actions/currentSongActoins";
function PlayButton({ playingFn, togglePlay }) {
  let [playing, setPlaying] = useState(false);
  console.log("plaing", playing);
  console.log("PlayButton rendered" + playingFn());
  const left = useRef({});
  const right = useRef({});
  const onPlayClick = (e) => {
    let playerState = getPlayerState();
    if (playerState === "stopped") {
      setPlaying(false);
    } else if (playerState === "playing") {
      setPlaying(true);
    } else if (playerState === "paused") {
      setPlaying(false);
    }
  };
  useEffect(() => {
    let interval = setInterval(() => {
      let playerState = getPlayerState();
      if (playerState === "stopped") {
        setPlaying(false);
      } else if (playerState === "playing") {
        setPlaying(true);
      } else if (playerState === "paused") {
        setPlaying(false);
      }
    }, 200);
    return function () {
      console.log("clear interval");
      window.clearInterval(interval);
    };
  }, []);
  useEffect(() => {
    console.log("render useEffect");
    if (playing) {
      console.log(true, left.current);
      anime({
        targets: right.current,
        d: [
          {
            value:
              "M 10.848 6.78 C 10.848 6.78 10.885 20.339 10.848 20.34 C 10.811 20.341 17.628 20.377 17.628 20.34 C 17.628 20.303 17.611 6.797 17.628 6.78 C 17.645 6.763 10.867 6.792 10.848 6.78 Z",
          },
        ],
        duration: 500,
        easing: "easeInOutQuad",
      });
      anime({
        targets: left.current,
        d: [
          {
            value:
              "M 1.348 6.659 C 1.348 6.659 1.311 20.381 1.348 20.344 C 1.385 20.307 8.136 20.34 8.136 20.34 L 8.136 6.78 L 1.348 6.659 Z",
          },
        ],
        duration: 400,
        easing: "easeInOutQuad",
      });
    } else {
      anime({
        targets: right.current,
        d: [
          {
            value:
              "M 9.492 9.492 C 9.492 9.492 9.629 17.626 9.592 17.627 C 9.555 17.628 18.977 13.615 18.977 13.578 C 18.977 13.541 18.965 13.358 18.982 13.341 C 18.999 13.324 9.511 9.504 9.492 9.492 Z",
          },
        ],
        duration: 500,
        easing: "easeInOutQuad",
      });
      anime({
        targets: left.current,
        d: [
          {
            value:
              "M 1.348 6.659 C 1.348 6.659 1.311 20.381 1.348 20.344 C 1.385 20.307 9.555 17.553 9.555 17.553 L 9.482 9.456 L 1.348 6.659 Z",
          },
        ],
        duration: 400,
        easing: "easeInOutQuad",
      });
    }
  }, [playing]);
  return (
    <div
      className="media-controls__play"
      onClick={onPlayClick}
      data-playing={false}>
      <div>
        <svg
          id="play-pause"
          width="30"
          height="30"
          viewBox="0 0 30 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            ref={left}
            id="left"
            d="M 1.348 6.659 C 1.348 6.659 1.311 20.381 1.348 20.344 C 1.385 20.307 9.555 17.553 9.555 17.553 L 9.482 9.456 L 1.348 6.659 Z"
            fill="white"
            stroke="white"
          />
          <path
            ref={right}
            id="right"
            d="M 9.492 9.492 C 9.492 9.492 9.629 17.626 9.592 17.627 C 9.555 17.628 18.977 13.615 18.977 13.578 C 18.977 13.541 18.965 13.358 18.982 13.341 C 18.999 13.324 9.511 9.504 9.492 9.492 Z"
            fill="white"
            stroke="white"
          />
        </svg>
      </div>
    </div>
  );
}
const mapStateToProps = (state, ownProps) => {
  return {
    playing: state.selectedSong.playing,
    playingFn: ownProps.playingFn,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    togglePlay: () => {
      dispatch(toggleCurrentSongPlay());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayButton);
